import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonFactoCohabitationCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Risoluzione Convivenza di fatto',
    path: '/mutazioni/persona/risoluzione-convivenza-di-fatto',
  },
];

export const ResolutionFactoCohabitationCrumbs = [
  ...SearchPersonFactoCohabitationCrumbs,
  {
    name: 'Risoluzione Convivenza di fatto',
    path: '/mutazioni/persona/risoluzione-convivenza-di-fatto/risoluzione',
  },
];
